// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__K7Xi7","noParent":"Loading_noParent__2IpcA","icon":"Loading_icon__XAFEo"};